import { Box, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';

/**
 * @param {function} next - Function to proceed to next step
 * @param {function} back - Function to go back to previous step
 * @param {function} cancel - Function to cancel the form
 * @param {boolean} isFirstStep - Whether this is the first step
 * @param {boolean} isLastStep - Whether this is the last step
 * @param {boolean} disabled - Whether the next/complete button should be disabled
 */
export default function FormButtonControls({
  next,
  back,
  cancel,
  isFirstStep,
  isLastStep,
  disabled = false,
}) {
  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      {isFirstStep && cancel && (
        <Button
          onClick={cancel}
          color="secondary"
          variant="outlined"
          startIcon={<CancelIcon />}
        >
          Abbrechen
        </Button>
      )}

      {back && !isFirstStep && (
        <Button onClick={back} variant="outlined" startIcon={<ArrowBackIcon />}>
          Zurück
        </Button>
      )}

      {next && (
        <Button
          onClick={next}
          variant="contained"
          color={isLastStep ? 'success' : 'primary'}
          disabled={disabled}
          endIcon={isLastStep ? <CheckIcon /> : <ArrowForwardIcon />}
        >
          {isLastStep ? 'Abschließen' : 'Weiter'}
        </Button>
      )}
    </Box>
  );
}
